/*
 * Z-Stack free gift offer
 * -----------------------
 * - Add to cart for the offer product ("Z-Stack + Free Gift") is intercepted: nothing is
 *   added; the "Claim your free gift" drawer ([data-zgift-drawer]) slides out instead.
 *   If the offer is already in the cart, the cart opens instead.
 * - "+ Add" ([data-zgift-add]) adds the chosen gift variant, qty 1, on the offer's
 *   subscription plan, closes the drawer and opens the cart.
 * - Cart: Rebuy Smart Cart when present (it hides the theme drawer), else the theme drawer.
 * - Clean-up (any time the cart changes): keep one offer line (the newest), qty 1.
 */
(function () {
  if (window.__zgiftLoaded) return;
  window.__zgiftLoaded = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  function config() {
    var el = document.querySelector('script[data-zgift-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var CFG = config();
  if (!CFG) return;

  function drawerEl() { return document.querySelector('[data-zgift-drawer]'); }

  function request(url, body) {
    return fetch(root + url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
        }
        return data;
      });
    });
  }

  // All offer products (main + extras): the cart may hold only one offer line in total.
  var OFFER_IDS = CFG.offerProducts && CFG.offerProducts.length ? CFG.offerProducts : [CFG.productId];
  function offerLines(cart) {
    return (cart.items || []).filter(function (i) { return OFFER_IDS.indexOf(i.product_id) !== -1; });
  }
  function onceLines(cart) {
    return (cart.items || []).filter(function (i) { return CFG.oneTimeVariant && i.variant_id === CFG.oneTimeVariant; });
  }
  // One bottle-deal or the other: remove these lines before adding the other kind.
  function removeLines(lines) {
    return lines.reduce(function (p, line) {
      return p.then(function () { return request('cart/change.js', { id: line.key, quantity: 0 }); });
    }, Promise.resolve());
  }
  function resync() { if (window.__zgiftSync) window.__zgiftSync(); }
  // Subscribe vs one-time on a product form. The theme's Subscribe/One-time toggle marks its mode on
  // [data-subscription-selector] (data-mode="subscription"|"onetime"); note the form also contains the
  // plan <select name="selling_plan">, which always has a value, so it can't be used to tell.
  function isSubscribe(form) {
    var sel = form.querySelector('[data-subscription-selector]') || document.querySelector('[data-subscription-selector]');
    if (sel && sel.dataset.mode) return sel.dataset.mode === 'subscription';
    var hidden = form.querySelector('input[type="hidden"][name="selling_plan"]');
    return !!(hidden && hidden.value);
  }

  // ---- Cart (Rebuy Smart Cart or theme drawer) ----------------------------------------
  function rebuy() { return window.Rebuy && window.Rebuy.Cart ? window.Rebuy : null; }

  function refreshCart() {
    var R = rebuy();
    if (R && typeof R.Cart.fetchCart === 'function') {
      try { return Promise.resolve(R.Cart.fetchCart()).catch(function () {}); } catch (e) { /* fall through */ }
    }
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));
    return Promise.resolve();
  }

  function openCart() {
    // The store's cart drawer is Recharge's; it opens via RechargePubSub.
    try { if (window.RechargePubSub) { window.RechargePubSub.publish('cart-drawer:open'); return; } } catch (e) {}
    var R = rebuy();
    if (R && R.SmartCart && typeof R.SmartCart.show === 'function') { R.SmartCart.show(); return; }
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.toggleDrawerClasses === 'function') {
      d.classList.remove('is-empty', 'wt-cart--empty');
      if (!d.isOpen) d.toggleDrawerClasses();
      return;
    }
    window.location = (window.routes && window.routes.cart_url) || '/cart';
  }

  // ---- Gift drawer ----------------------------------------------------------------------
  var lastFocus = null;

  function openDrawer() {
    var el = drawerEl();
    if (!el) return;
    lastFocus = document.activeElement;
    var err = el.querySelector('[data-zgift-error]');
    if (err) err.hidden = true;
    el.querySelectorAll('[data-zgift-add]').forEach(function (b) { b.disabled = false; b.classList.remove('is-loading'); });
    el.hidden = false;
    document.documentElement.classList.add('zgift-lock');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-open'); });
    });
    var panel = el.querySelector('.zgift-drawer__panel');
    if (panel) panel.focus();
  }

  function closeDrawer() {
    var el = drawerEl();
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('zgift-lock');
    setTimeout(function () { el.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // ---- Product page Add to cart → gift drawer -------------------------------------------
  // Capture phase on document runs before the theme's <product-form> submit handler.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var idInput = form && form.querySelector && form.querySelector('[name="id"]');
    if (!idInput || CFG.variants.indexOf(Number(idInput.value)) === -1) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    // One-time mode of the theme's Subscribe/One-time toggle (selling_plan left empty): offer
    // variants are gifts and subscription-only, so add the one-time product (regular Z-Stack) instead.
    // (No plan field at all = the toggle never set one up, e.g. the product has no plan yet.)
    if (!isSubscribe(form) && CFG.oneTimeVariant) {
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      request('cart.js')
        .then(function (cart) {
          if (onceLines(cart).length) { openCart(); return; } // already in the cart: "View cart"
          return removeLines(offerLines(cart))
            .then(function () { return request('cart/add.js', { items: [{ id: CFG.oneTimeVariant, quantity: qty }] }); })
            .then(function () { return refreshCart().then(openCart); });
        })
        .catch(function (ex) { console.warn('[zgift] One-time add failed', ex); })
        .then(resync);
      return;
    }

    request('cart.js')
      .then(function (cart) { if (offerLines(cart).length) openCart(); else openDrawer(); })
      .catch(openDrawer);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-zgift-close]')) { e.preventDefault(); closeDrawer(); return; }

    // "Purchase Z-Stack without a subscription": any link to #zgift-onetime adds the
    // one-time product (no selling plan, qty 1) and opens the cart.
    var oneTime = e.target.closest('a[href$="#zgift-onetime"]');
    if (oneTime) {
      e.preventDefault();
      if (busy || !CFG.oneTimeVariant) return;
      busy = true;
      oneTime.classList.add('is-loading');
      request('cart/add.js', { items: [{ id: CFG.oneTimeVariant, quantity: 1 }] })
        .then(function () { busy = false; return refreshCart().then(openCart); })
        .catch(function (ex) { busy = false; console.warn('[zgift] One-time add failed', ex); })
        .then(function () { oneTime.classList.remove('is-loading'); });
      return;
    }

    var add = e.target.closest('[data-zgift-add]');
    if (!add || busy) return;
    e.preventDefault();

    var el = drawerEl();
    var err = el && el.querySelector('[data-zgift-error]');
    var buttons = el ? el.querySelectorAll('[data-zgift-add]') : [add];
    if (err) err.hidden = true;
    buttons.forEach(function (b) { b.disabled = true; });
    add.classList.add('is-loading');
    busy = true;

    request('cart.js')
      .then(function (cart) {
        // Never two offer lines (drop an existing one, e.g. when changing the gift), and the offer
        // replaces a one-time bottle.
        return removeLines(offerLines(cart).concat(onceLines(cart)));
      })
      .then(function () {
        return request('cart/add.js', {
          items: [{ id: Number(add.dataset.variantId), quantity: 1, selling_plan: Number(add.dataset.sellingPlan) }],
        });
      })
      .then(function () {
        busy = false;
        closeDrawer();
        resync();
        return refreshCart().then(openCart);
      })
      .catch(function (ex) {
        busy = false;
        if (err) { err.textContent = ex.message; err.hidden = false; }
        buttons.forEach(function (b) { b.disabled = false; });
        add.classList.remove('is-loading');
      });
  });

  // ---- Classic product page: "View cart" + "In your cart" note ----------------------------
  // (The zso landing page has its own version of this in zso-cart.js.)
  (function classicPage() {
    if (document.getElementById('zso')) return;
    var form = Array.prototype.find.call(document.querySelectorAll('form'), function (f) {
      var i = f.querySelector('[name="id"]');
      return i && CFG.variants.indexOf(Number(i.value)) !== -1;
    });
    if (!form) return;
    var btn = form.querySelector('[type="submit"]');
    var label = btn && (btn.querySelector('span') || btn);
    var original = label ? label.textContent : '';
    var host = form.closest('product-form') || form;
    var note = document.createElement('p');
    note.className = 'zgift-incart';
    note.hidden = true;
    note.innerHTML = '<span class="zgift-incart__tick" aria-hidden="true"></span>In your cart: <strong data-zgift-incart-name></strong> is your free gift ' +
      '<button type="button" class="zgift-incart__change">Change gift</button>';
    host.parentNode.insertBefore(note, host.nextSibling);
    note.querySelector('button').addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });

    var state = { offer: null, once: null };
    var quietUntil = 0; // Recharge re-publishes cart events for every /cart request, ours included
    var timer = null;

    function render() {
      var sub = isSubscribe(form);
      var inCart = sub ? state.offer : state.once;
      if (label) label.textContent = inCart ? 'View cart' : original;
      note.hidden = !(sub && state.offer);
      if (state.offer) note.querySelector('[data-zgift-incart-name]').textContent = state.offer.variant_title || 'Your gift';
    }
    function sync() {
      quietUntil = Date.now() + 1500;
      return request('cart.js').then(function (cart) {
        state.offer = offerLines(cart)[0] || null;
        state.once = onceLines(cart)[0] || null;
        render();
      }).catch(function () {});
    }
    function soon() {
      if (Date.now() < quietUntil) return;
      clearTimeout(timer);
      timer = setTimeout(sync, 300);
    }
    window.__zgiftSync = function () { setTimeout(sync, 800); };

    // The theme's Subscribe/One-time toggle updates the hidden selling_plan field on change.
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('[data-subscription-selector]')) setTimeout(render, 0);
    });
    (function hook(tries) {
      if (window.RechargePubSub) {
        ['cart:update', 'cart:item:add', 'cart:item:update'].forEach(function (n) { window.RechargePubSub.subscribe(n, soon); });
      } else if (tries < 40) setTimeout(function () { hook(tries + 1); }, 250);
    })(0);
    window.addEventListener('pageshow', sync);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') sync(); });
    if (document.readyState === 'complete') sync(); else window.addEventListener('load', sync);
  })();

  // ---- Clean-up: one offer line, qty 1 ---------------------------------------------------
  var checkTimer = null;

  function enforce() {
    if (busy) return;
    request('cart.js').then(function (cart) {
      var lines = offerLines(cart);
      var fixes = [];
      lines.forEach(function (line, i) {
        // Shopify lists the newest line first: keep it.
        if (i > 0 || !line.selling_plan_allocation) fixes.push({ id: line.key, quantity: 0 });
        else if (line.quantity > 1) fixes.push({ id: line.key, quantity: 1 });
      });
      if (!fixes.length) return;
      busy = true;
      return fixes.reduce(function (p, f) {
        return p.then(function () { return request('cart/change.js', f); });
      }, Promise.resolve())
        .catch(function (ex) { console.warn('[zgift] Clean-up failed', ex); })
        .then(function () { busy = false; return refreshCart(); });
    }).catch(function () {});
  }

  function scheduleCheck() {
    clearTimeout(checkTimer);
    checkTimer = setTimeout(enforce, 400);
  }

  // Rebuy fires rebuy:cart.change; the theme publishes cart updates on its own drawer.
  ['rebuy:cart.change', 'rebuy:cart.add', 'cart-drawer:refresh'].forEach(function (name) {
    document.addEventListener(name, scheduleCheck);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleCheck);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleCheck);
  else scheduleCheck();
})();
